import React, {useEffect} from 'react'
import './styles/TableBienes.css'
import './styles/TableBienes2.css'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {ProductosF} from '../../../../interfaces/facturacion.interface'
import {
  facturacionArrayProductoSelectOne,
  facturacionModalsOpenEliminar,
  facturacionOpenModalEditar,
} from '../../../../actions/facturacion/facturacionProductos.actions'
import {bindActionCreators} from 'redux'
import {actionFacturacionProducto} from '../../../../actions/action-creators'
import TablaFacturacionCF from './TablaFacturacionCF'

const TablaBienesServiciosCF = () => {
  const arrayProductos: Array<ProductosF> = useSelector((state: State) => state.facturacion.arrayProductos)
  const checkContribuyente = useSelector((state: State) => state.facturacion.formCliente.checkContribuyente)
  const checkExentoImpuesto = useSelector((state: State) => state.facturacion.formCliente.checkExentoImpuesto)
  const checkPropina = useSelector((state: State) => state.facturacion.formCliente.checkPropina)
  const datosEmisor = useSelector((state: State) => state.catalogos.datosEmisor)
  const calculos = useSelector((state: State) => state.facturacion.calculosArrayProductos)
  const idDoc = useSelector((state: State) => state.documentos.activeDoc?.idDoc)
  const userLogin = useSelector((state: State) => state.userLogin)
  const dispatch = useDispatch()
  const {facturacionCalculoTotalArrayProducto} = bindActionCreators(actionFacturacionProducto, dispatch)

  useEffect(() => {
    facturacionCalculoTotalArrayProducto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrayProductos, checkContribuyente, checkExentoImpuesto, checkPropina, datosEmisor, idDoc])

  const openModalEliminar = (i: number) => {
    dispatch(facturacionArrayProductoSelectOne(i))
    dispatch(facturacionModalsOpenEliminar())
  }

  const openModalEditar = (i: number, producto: ProductosF) => dispatch(facturacionOpenModalEditar(i, producto))

  return (
    <>
      <h3 className='card-title l'>Detalle de Productos ó Servicios</h3>
      <div className='form-separator'></div>
      <TablaFacturacionCF propina={userLogin?.propina} datos={calculos} arrayProductos={arrayProductos} rows={arrayProductos} openModalEliminar={openModalEliminar} openModalEditar={openModalEditar} idDoc={idDoc} sinAcciones={false} checkExentoImpuesto={checkExentoImpuesto} checkPropina={checkPropina}/>
    </>
  )
}

export default TablaBienesServiciosCF
